import React, { useEffect, useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import './NewsArticleView.css'

const API_BASE = process.env.REACT_APP_API_BASE || 'https://backend.alephmedia.ro/api'

function NewsArticleView() {
  const { slug } = useParams()
  const navigate = useNavigate()
  const [article, setArticle] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!slug) {
      setLoading(false)
      return
    }
    setLoading(true)
    setError(null)
    fetch(`${API_BASE}/internal-news/by-slug/${encodeURIComponent(slug)}`)
      .then((res) => {
        if (!res.ok) {
          if (res.status === 404) throw new Error('Articol negăsit')
          throw new Error('Eroare la încărcare')
        }
        return res.json()
      })
      .then((data) => {
        if (data.success && data.data) {
          setArticle(data.data)
        } else {
          setError('Articol negăsit')
        }
      })
      .catch((err) => {
        setError(err.message || 'Eroare la încărcare')
      })
      .finally(() => setLoading(false))
  }, [slug])

  const publishedDate = article?.published_at
    ? new Date(article.published_at).toLocaleDateString('ro-RO', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      })
    : null

  return (
    <div className="news-view-root">
      <div className="news-view-header">
        <button type="button" className="news-view-back" onClick={() => navigate(-1)} aria-label="Înapoi">
          <svg width="41" height="34" viewBox="0 0 41 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.3333 21.6667L3 12.3333M3 12.3333L12.3333 3M3 12.3333H28.6667C31.142 12.3333 33.516 13.3167 35.2663 15.067C37.0167 16.8173 38 19.1913 38 21.6667C38 24.142 37.0167 26.516 35.2663 28.2663C33.516 30.0167 31.142 31 28.6667 31H26.3333" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>

      {loading && <div className="news-view-status">Se încarcă articolul...</div>}
      {error && <div className="news-view-status news-view-status-error">{error}</div>}

      {!loading && !error && article && (
        <div className="news-view-content">
          <div className="news-view-hero">
            {article.image_url && (
              <div className="news-view-poster">
                <img src={article.image_url} alt={article.title} />
              </div>
            )}
            <h1>{article.title}</h1>

            <div className="news-view-meta">
              {article.category && (
                <span className="news-view-category">{article.category}</span>
              )}
              {publishedDate && (
                <span className="news-view-date">{publishedDate}</span>
              )}
            </div>

            {Array.isArray(article.tags) && article.tags.length > 0 && (
              <div className="news-view-tags">
                {article.tags.map((tag, i) => (
                  <span key={i} className="news-view-tag">{tag}</span>
                ))}
              </div>
            )}
          </div>

          <div
            className="news-view-body"
            dangerouslySetInnerHTML={{ __html: article.content || '' }}
          />
        </div>
      )}
    </div>
  )
}

export default NewsArticleView
